module.exports = __webpack_public_path__ + "01_glasses_brown.9653a91a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer4/01_glasses_brown.png
// module id = fe1N
// module chunks = 0